import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import { WsRequest } from '../requests/request.types';
import { GetCalendarEventsRequestSchema } from '../types/calendar/event_request_pb';
import {
  GetCalendarIntegrationEnabledRequest,
  GetE2eeIntegrationEnabledRequest,
  GetE2eeIntegrationEnabledRequestSchema,
} from '../types/config/config_request_pb';
import {
  GetCalendarIntegrationEnabledResponse,
  GetE2eeIntegrationEnabledResponse,
} from '../types/config/config_response_pb';

export function getCalendarIntegrationEnabledRequest(
  data: WsRequest<GetCalendarIntegrationEnabledRequest>
): Promise<GetCalendarIntegrationEnabledResponse> {
  return wsAppRequestManager.request<GetCalendarIntegrationEnabledResponse>({
    case: 'getCalendarIntegrationEnabled',
    value: create(GetCalendarEventsRequestSchema, data),
  });
}

export function getE2eeIntegrationEnabledRequest(
  data: WsRequest<GetE2eeIntegrationEnabledRequest>
): Promise<GetE2eeIntegrationEnabledResponse> {
  return wsAppRequestManager.request<GetE2eeIntegrationEnabledResponse>({
    case: 'getE2eeIntegrationEnabled',
    value: create(GetE2eeIntegrationEnabledRequestSchema, data),
  });
}
